module.exports = Em.ArrayController.extend({
    init: function() {
        this.set('content', [])
        this._super()
    }
})
